import { createRouter, createWebHistory } from 'vue-router'
//import HomeView from '../views/HomeView.vue'
import DetectionAuth from '../components/DetectionAuth.vue'
import DetectionAuthQR from '../components/DetectionAuthQR.vue'
import DetectionsList from '../components/DetectionsList.vue'
import DetectionDoc from '../components/DetectionDoc.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/list',
      name: 'Главная',
      component: DetectionsList
    },
    {
      path: '/auth',
      name: 'Авторизация',
      component: DetectionAuth
    },
    {
      path: '/authQR:auth_string',
      name: 'Авторизация через QR',
      component: DetectionAuthQR
    },
    {
      path: '/list',
      name: 'Список документов',
      component: DetectionsList
    },
    {
      path: '/doc/:doc_guid',
      name: 'Документ',
      component: DetectionDoc
      //props: (route) => ({ doc-guid: route.query.guid })
    }
  ]
})

export default router
